import {Injectable} from '@angular/core';
import {HttpClient} from "@angular/common/http";
import {environment} from "../../environments/environment";

@Injectable()
export class ModuleService {

    constructor(private http: HttpClient) {
    }

    getModules() {
        let url = `${environment.apiUrl}modules/`;
        return this.http.get(url).toPromise();
    }
}



// WEBPACK FOOTER //
// /Users/dominik/Documents/projekty/guru-apps-saas/src/app/shared/module.service.ts